import { useEffect, useState } from 'react';
import { API, getFromLocalStorageByKey } from '@vfit/shared/data-access';
import { ICommonData } from '@vfit/shared/models';
import { Skeleton } from '@vfit/shared/components';
import {
  CONSUMER_CMS_SHOPPING_CART,
  IGenericErrorCMS,
  useCmsConfig,
  useRetrieveMultiLines,
} from '@vfit/consumer/data-access';
import { useCheckout } from '../../../iBuyFixed.context';
import { skeletonShape } from './components/ConsentsList/consentsList.style';
import ConsentsList from './components/ConsentsList/consentsList';
import TaggingConsentCard from './consentCard.tagging';

const ConsentCard = (props: ICommonData) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { checkoutErrors, setIsDisabledBackButton } = useCheckout();
  const genericError = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_GENERIC_ERROR
  ) as IGenericErrorCMS;

  const {
    error: retrieveMultilinesError,
    isSuccess: isSuccessRetrieveMultilines,
    isError: isErrorRetrieveMultilines,
    isLoading: isLoadingRetrieveMultilines,
    mutate: retrieveMultilinesMutation,
  } = useRetrieveMultiLines();

  const checkRetrieveMultilines = () => {
    const retrieveMultilines = getFromLocalStorageByKey('retrieveMultiLines');
    if (retrieveMultilines) setIsLoading(false);
    else retrieveMultilinesMutation();
  };

  useEffect(() => {
    if (isErrorRetrieveMultilines) {
      const { handleOnClose } = props || {};
      checkoutErrors?.showAndTrackError?.(genericError, () => handleOnClose?.(), {
        ...retrieveMultilinesError,
        isBlocking: true,
      });
    } else if (isSuccessRetrieveMultilines) {
      setIsLoading(false);
    }
  }, [isLoadingRetrieveMultilines, isErrorRetrieveMultilines, isSuccessRetrieveMultilines]);

  useEffect(() => {
    setIsDisabledBackButton(isLoading);
  }, [isLoading]);

  useEffect(() => {
    checkRetrieveMultilines();
  }, []);

  return (
    <>
      <TaggingConsentCard />
      {isLoading && <Skeleton {...skeletonShape} />}
      {!isLoading && <ConsentsList {...props} />}
    </>
  );
};

export default ConsentCard;

